import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

export const HeaderArea = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: rgb(210, 235, 239);
  border-top: 8px solid rgb(104, 157, 165);
  color: rgb(104, 157, 165);
  padding: 8px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const HeaderContainer = styled.div`
  max-width: 1368px;
  padding: 0 20px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 992px) {
    flex-wrap: wrap;
    padding: 0 16px;
  }
`

export const Icon = styled.img`
  width: auto;
  height: 80px;
  max-height: 100%;
  object-fit: contain;
  margin-right: 24px;

  @media (max-width: 768px) {
    height: 64px;
  }

  @media (max-width: 480px) {
    height: 48px;
    margin-right: 12px;
  }
`

export const Burger = styled.div`
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;

  span {
    width: 25px;
    height: 3px;
    background: #2a5a69;
    border-radius: 3px;
    transition: 0.3s;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`

export const TextSide = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`

export const NavList = styled.ul`
  list-style: none;
  display: flex;
  gap: 16px;

  @media (max-width: 768px) {
    display: none;

    &.open {
      display: none;
    }
  }
`

export const ListItem = styled.a`
  font-weight: 600;
  cursor: pointer;
  transition: color 0.3s;
  list-style: none;
  text-align: center;
  text-decoration: none;

  &:hover {
    color: #397a89;
  }
`
export const LinkNav = styled(NavLink)`
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  color: rgb(60, 132, 154);
  transition: color 0.3s ease, border-bottom 0.3s ease;
  padding-bottom: 4px;

  &:hover {
    color: rgb(86, 116, 123);
  }

  &.active {
    color: rgb(27, 108, 121);
  }
`
export const ButtonNavLink = styled(NavLink)`
  text-decoration: none;
  cursor: pointer;
  color: rgb(192, 215, 219);
`

export const NaviButton = styled.a`
  background: linear-gradient(45deg, #68b0b9, #2a5a69);
  color: white;
  padding: 12px 20px;
  font-weight: bold;
  font-size: 13px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: linear-gradient(45deg, #2a5a69, #68b0b9);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 10px 16px;
  }
`

export const MobileMenu = styled.ul`
  display: none;
  flex-direction: column;
  background-color: #c1dee3;
  padding: 12px 20px;
  gap: 10px;

  &.open {
    display: flex;
  }

  @media (min-width: 769px) {
    display: none !important;
  }

  li {
    padding: 10px;
    border-bottom: 1px solid #2a5a69;
  }
`
